export default {
	SET_BATCH_QUANTITY: 'SET_BATCH_QUANTITY',
	TOGGLE_PRODUCT_OPTION: 'TOGGLE_PRODUCT_OPTION', 
	APPLY_FILTER_TO_BATCH: 'APPLY_FILTER_TO_BATCH', 
	SET_PRODUCT_BATCH: 'SET_PRODUCT_BATCH'
}